module.exports = __webpack_public_path__ + "static/media/CWU-off.0bfbe548.svg";